// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 824) return "static/chunks/824.c1dc2308dc764df5.js";
	if (chunkId === 282) return "static/chunks/282.04a5e7712942ac2b.js";
	if (chunkId === 49) return "static/chunks/video-players.f9e07b5cc006aaaf.js";
	// return url for filenames based on template
	return "static/chunks/" + {"76":"common","108":"magalu-libs-1ac24d32","413":"magalu-libs-51c13596","503":"magalu-libs-7442fa49","527":"magalu-libs-187d0317","813":"magalu-components"}[chunkId] + "-" + {"76":"8fd96bcd3d11b76c","108":"7e690b365733d59e","413":"1398f5498d9a0e9a","503":"761294341d8b2ed0","527":"91fc9d5831a75100","813":"2afa3cd20ca24244"}[chunkId] + ".js";
};